// extracted by mini-css-extract-plugin
export var resizer = "_ew-0";